module.exports = __webpack_public_path__ + "img/product-pages-use-case.ac6f016a.png";